import moment from 'moment';

export const dateFormat = (
  value: string | null | undefined,
  format: string = 'YYYY.MM.DD'
) => {
  if (typeof value !== 'string') {
    return value;
  }
  return moment(value).format(format);
};

